import React, { Component } from 'react';
import { renderRoutes } from 'react-router-config';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Modal from 'react-bootstrap/lib/Modal';
import Link from 'react-router-dom/Link';
import NavLink from 'react-router-dom/NavLink';
import smallNumberString from 'anchor-server-common/utilities/smallNumberString';
import PageSectionWithWaveContainer from '../PageSectionWithWaveContainer';
import PageHeader from '../PageHeader';
import Footer from '../Footer';
import AvatarWithNameAndBio from '../AvatarWithNameAndBio';
import CreateEpisodeContainer from '../CreateEpisodeContainer';
import USER_PERMISSIONS from '../../../helpers/userPermissions';
import styles from './styles.sass';

const PENDING_STATUS = 'pending';

class Partner extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleClickCreateEpisode = this.handleClickCreateEpisode.bind(this);
  }

  handleClickCreateEpisode(evt) {
    const {
      actions: { createEpisode, clickPartnerAnalytics },
    } = this.props;
    evt.preventDefault();
    createEpisode();
    clickPartnerAnalytics('Create Episode');
  }

  render() {
    const {
      actions: { cancelCreateEpisode },
      children,
      segments = [],
      actions,
      bio,
      isCreating,
      isFetching,
      user,
      permissions,
      totalPlayCount,
      episodeCount,
      followerCount,
    } = this.props;
    const { name, imageUrl, userId } = user || {}; // null case before state populated
    return (
      <div className={`${styles.archive} isV2LegacyPage`}>
        <PageSectionWithWaveContainer
          backgroundClassName={styles.pageHeaderBackground}
        >
          <PageHeader
            className={styles.legalPageHeader}
            title="Partner dashboard"
          />
        </PageSectionWithWaveContainer>
        <Grid className={styles.content}>
          <Row className={styles.statRow}>
            <Col md={6} className={styles.avatarContainer}>
              <AvatarWithNameAndBio
                name={name}
                bio={bio}
                imageUrl={imageUrl}
                userId={userId}
                nameContainerClassName={styles.userName}
              />
            </Col>
            <Col md={2} className={styles.statCallout}>
              {totalPlayCount !== null && (
                <span>
                  <span className={styles.dataPoint}>
                    {smallNumberString(totalPlayCount)}
                  </span>{' '}
                  Total Plays
                </span>
              )}
            </Col>
            <Col md={2} className={styles.statCallout}>
              {followerCount !== null && (
                <span>
                  <span className={styles.dataPoint}>
                    {smallNumberString(followerCount)}
                  </span>{' '}
                  Favorited
                </span>
              )}
            </Col>
            <Col md={2} className={styles.statCallout}>
              {episodeCount !== null && (
                <span>
                  <span className={styles.dataPoint}>{episodeCount}</span>{' '}
                  Episodes
                </span>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12} className={styles.tabs}>
              {permissions &&
                permissions[USER_PERMISSIONS.PARTNER_ANALYTICS] && (
                  <NavLink
                    to="/partner/analytics"
                    activeClassName={styles.activeTab}
                  >
                    Segments
                  </NavLink>
                )}
              {permissions &&
                permissions[USER_PERMISSIONS.PARTNER_ANALYTICS] &&
                permissions[USER_PERMISSIONS.EPISODES] && (
                  <span className={styles.tabSep}>|</span>
                )}
              {permissions &&
                permissions[USER_PERMISSIONS.EPISODES] && (
                  <NavLink
                    to="/partner/episodes"
                    activeClassName={styles.activeTab}
                  >
                    Episodes
                  </NavLink>
                )}
              {permissions &&
                permissions[USER_PERMISSIONS.EPISODES] && (
                  <a
                    className={`${styles.addEpisode} pull-right`}
                    href
                    onClick={this.handleClickCreateEpisode}
                  >
                    Add Episode
                  </a>
                )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>{renderRoutes(this.props.route.routes)}</Col>
          </Row>
        </Grid>
        <Footer />
        <Modal
          className={styles.withHeading}
          show={isCreating}
          onHide={cancelCreateEpisode}
        >
          <Modal.Header closeButton>
            <h3 className="text-center">Name your Episode</h3>
          </Modal.Header>
          <Modal.Body>
            <CreateEpisodeContainer />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default Partner;
